import { fromJS } from 'immutable';
import { DocumentTypesEnum } from '../document-data/document-data.data';
import { Document } from '../document-data/document.model';

export class CreditMemo extends Document {
  static ENTITY_TYPE: DocumentTypesEnum = DocumentTypesEnum.credit_memo;
  static KEYS: any = Document.KEYS;
  static CONTENT_KEYS: any = Document.CONTENT_KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get ENTITY_TYPE(): string {
    return CreditMemo.ENTITY_TYPE;
  }
}
